export const galleryData = [
  {
    title: "Fashion",
    slug: "fashion",
    cover: "https://ik.imagekit.io/p3xaqnkci/tagteam/fashioncover.webp",
    subCategories: [
      {
        title: "Editorial",
        slug: "editorial",
        images: [
          "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/fashion/f1.jpg",
          "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/fashion/f2.jpg",
          "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/fashion/f3.jpg",
        ],
      },
      {
        title: "Street",
        slug: "street",
        images: [
          "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/fashion/s1.jpg",
          "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/fashion/s2.jpg",
        ],
      },
    ],
  },
  {
    title: "Weddings",
    slug: "wedding",
    cover: "https://ik.imagekit.io/p3xaqnkci/tagteam/weddingcover.webp",
    subCategories: [
      {
        title: "Traditional",
        slug: "traditional",
        images: [
          "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/wedding/w1.jpg",
          "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/wedding/w2.jpg",
        ],
      },
    ],
  },
  {
    title: "Toddler",
    slug: "toddler",
    cover: "assets/toddlers-webp/t47.webp",
    subCategories: [
      {
        title: "Kids Shoot",
        slug: "kids-shoot",
        images: [
          "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/Toddlers/t1.jpg",
          "https://ik.imagekit.io/p3xaqnkci/tr:f-auto,q-auto,w-1200/tagteam/Toddlers/t2.jpg",
        ],
      },
    ],
  },
];
